module.exports = __webpack_public_path__ + "static/media/Donutjar.62b269a3.png";